module.exports = __webpack_public_path__ + "static/media/m7tj0.6aee8b67.png";